import "./Home_Styles/Image_box_first.css";

const Image_box_first = () => {
    return (
        <div className="Home_image_box_1">
            <div><img src="https://cdn01.pharmeasy.in/dam/banner/banner/fcbf95577c3-VELCRO.jpg?dim=1440x0" alt="" /></div>
            <div><img src="https://cdn01.pharmeasy.in/dam/banner/banner/a9ad640ce01-4.jpg?dim=1440x0" alt="" /></div>
            <div><img src="https://cdn01.pharmeasy.in/dam/banner/banner/93ef9d6df4f-SLIPPERS.jpg?dim=1440x0" alt="" /></div>
            <div><img src="https://cdn01.pharmeasy.in/dam/banner/banner/6e16a38ea89-ORTHO_PEDOC.jpg?dim=1440x0" alt="" /></div>
        </div>
    );
}

export {Image_box_first};